//------------------------------------------------------------------------------
// API -------------------------------------------------------------------------
import client from '@api/client';
//------------------------------------------------------------------------------
// Exports ---------------------------------------------------------------------
export const loadReferral = (id) => {
  return client.get(`/referrals/${id}`);
};
